<template>
    <v-container >
        <hrm-employee-appointment-letter  
            v-if="pathName === 'appointment-letter'"
            :employeeDetails="employeeDetails"
            :getFileServerUrl="getFileServerUrl"
            :getCurrentDate="getCurrentDate"
            :formattedDate="formattedDate"
            :id="id"
        />
        <hrm-employee-increment-letter  
            v-else-if="pathName === 'increment-letter'"
            :employeeDetails="employeeDetails"
            :getFileServerUrl="getFileServerUrl"
            :getCurrentDate="getCurrentDate"
            :formattedDate="formattedDate"
            :id="id"
        />
        <hrm-employee-promotion-letter  
            v-else-if="pathName === 'promotion-letter'"
            :employeeDetails="employeeDetails"
            :getFileServerUrl="getFileServerUrl"
            :getCurrentDate="getCurrentDate"
            :formattedDate="formattedDate"
            :id="id"
        />
        <v-row v-else>
            <v-col align="center" cols="12">
                <v-card>
                    <v-card-text>No Letter Found</v-card-text>
                </v-card>
            </v-col>
        </v-row> 
    </v-container>
</template>

<script>

import formattedDate from "@/plugins/dateFormatter";

import hrmEmployeeAppointmentLetter from "@/components/module/hrm/employeeLetterManagement/hrmEmployeeAppointmentLetter.vue";
import hrmEmployeeIncrementLetter from "@/components/module/hrm/employeeLetterManagement/hrmEmployeeIncrementLetter.vue";
import hrmEmployeePromotionLetter from "@/components/module/hrm/employeeLetterManagement/hrmEmployeePromotionLetter.vue";

export default {
    components: {
        hrmEmployeeAppointmentLetter,
        hrmEmployeeIncrementLetter,
        hrmEmployeePromotionLetter
    },
    data: () => ({
        employeeDetails: null,
        leaveTypesData: null,
        pathName: null,
    }),

    watch: {
        pathName(val) {
            console.log(val);
        }
    },
    
    created() { },
    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
        getCurrentDate() {
            const date = new Date();
            return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },
    },
    methods: {
        formattedDate,
        
    },
    setup() {},
    mounted() {
        const id = this.$route.query.id;
        this.$store.dispatch("getEmployeeDetails", id).then(res => {
            this.employeeDetails = res.data.data;
        })

        const routes = this.$route.path;

        if (routes.includes("promotion-letter")) {
            this.pathName = "promotion-letter";
        } else if (routes.includes("increment-letter")) {
            this.pathName = "increment-letter";
        } else {
            this.pathName = "appointment-letter";
        }
    },  
    beforeUnmount() {}
}
</script>